import BaseModelAPI from '../BaseModelAPI';

export default class UserInfoList extends BaseModelAPI {

	static entity = 'userinfolist'
	static entityName = 'userinfo';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
